module.exports = __webpack_public_path__ + "static/media/ios-collage.6aab917c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ios-collage.png
// module id = 56
// module chunks = 1